module.exports = __webpack_public_path__ + "img/clock.ae6b6c3f.svg";